import type { RouterOutputs } from "~/utils/api";

export interface AccordionData {
  id: string;
  title: string;
  content: string;
}

export interface DialogData {
  tag: string | undefined;
  tagColor: string | undefined;
  title: string;
  markdown: string;
  accordion: AccordionData[] | undefined;
}

export interface RecommendationData {
  id: string;
  text: string;
  image?: string;
  dialog: DialogData;
  tag: string | undefined;
  tagColor: string | undefined;
}

type PlainRecommendationInfo =
  RouterOutputs["dashboard"]["getHmtRecommendation"]["data"];

export const normalizeRecommendations = (
  data: PlainRecommendationInfo,
): RecommendationData[] => {
  return data.map((rec, i) => {
    return {
      id: "rec" + i,
      text: rec.title,
      image: rec.image ?? "/recommendations/default.png",
      tag: rec.type,
      tagColor: rec.color,
      dialog: {
        tag: rec.type,
        tagColor: rec.color,
        title: rec.title,
        markdown: rec.content,
        accordion: rec.terminologyExplanation?.map((item, i) => {
          return {
            id: "term" + i,
            title: item.title,
            content: item.explanation,
          };
        }),
      },
    };
  });
};
